var React = require('react');

function Play24x24 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Inverted=off, Size=24x24"},React.createElement("path",{"id":"Polygon 2","d":"M21.784 13.77c1.425-.75 1.425-2.79 0-3.54L5.932 1.887C4.6 1.186 3 2.15 3 3.657v16.687c0 1.505 1.6 2.47 2.931 1.77l15.853-8.344z","stroke":"currentColor","strokeWidth":"2"})));
}

Play24x24.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Play24x24;

Play24x24.default = Play24x24;
